<template>
  <b-modal 
    id="welcome-popup"
    ref="welcome-popup"
    v-model="show" 
    size="lg"
    centered
    hide-footer
    hide-header
    body-class="p-0"
    content-class="bg-transparent"
    @hide="storePopupViewed()"
    >
      <div class="row welcome-popup-content">
        <a class="welcome-close-link d-none d-md-block" href="#" @click="hideModal">
          <i class="fa fa-times"></i>
        </a>
        <a class="welcome-mobile-close-link text-left position-absolute text-white p-3 w-100"         
          href="#" 
          @click="hideModal">
          <i class="fa fa-times"></i>
        </a>        
        <div class="col-md-4 px-3 welcome-right-side">
          <div class="welcome-inner-content mt-4 pt-lg-5">
            <h1 class="text-white px-3 px-md-0 mb-2">{{hebrew ? 'ברוכים הבאים' : 'Welcome'}}</h1>
            <p class="text-white d-none d-md-block">
              רוצים לדעת באלו הקשרים<br/>
              המילה <strong>חיים</strong> מופיעה בתנ״ך?
            </p>
            <p class="text-white d-none d-md-block">הזינו את המילה <strong>חיים</strong> 
            וקבלו<br/> 
            <strong>מים חיים, בארץ החיים, עץ<br>
               חיים</strong>
            ועוד.
            </p>
            <p class="d-block d-md-none text-white px-3">
              הידעתם שהמילה חיים מופיעה<br/>
              בתנ״ך בביטויים כמו עץ חיים,<br/>
              מים חיים ועוד?
            </p>  
          </div>
        </div>
        <div class="col-md-8 welcome-left-side px-4">
          <p class="mt-4 pt-lg-5 px-2">
            הכלי לאיתור ביטויים מאפשר להזין מילת חיפוש ולקבל את<br/>
            הביטויים הנפוצים בתנ״ך ובתלמוד שכוללים את אותה המילה.
          </p>
          <div class="row mb-2 mb-md-3 px-2">
            <div class="col-1"><i class="fas fa-arrow-left"></i></div>
            <div class="col-10 pr-1 p-md-0 mx-md-n2">לבחירתכם, תוצאות מהתנ״ך או מהתלמוד.</div>
          </div>
          <div class="row mb-2 mb-md-3 px-2">
            <div class="col-1"><i class="fas fa-arrow-left"></i></div>
            <div class="col-10 pr-1 p-md-0 mx-md-n2">ניתן להגדיר את מספר המילים שיכלול הביטוי.</div>
          </div>
          <div class="row px-2">
            <div class="col-1"><i class="fas fa-arrow-left"></i></div>
            <div class="col-10 pr-1 p-md-0 mx-md-n2">התוצאות מוצגות גם בתצוגת גרף שמציג את הקשרים<br>
            בין הביטוי לספרים בו הוא מופיע</div>
          </div>                       
        </div>       
    </div>
    <div 
      class="d-block d-md-none text-center w-100 position-absolute mobile-close"
    >
      <b-btn 
        class="btn btn-md rounded-pill px-5"
        @click="hideModal"
        variant="secondary"
        size="lg"
        >סגור</b-btn>
    </div>      
  </b-modal>
</template>

<script>
export default {
  name: 'Welcome',
  data () {
    return {
    }
  },
  props: ["value"],
  computed: {
    hebrew () {
      return this.$settings.hebrew
    }, 
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    storePopupViewed () {
      window.localStorage.setItem('top-phrases-popup-viewed', true)
    },
    hideModal() {
      this.$refs['welcome-popup'].hide()
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
@media (min-width: 768px) and (max-device-width : 1024px)
and (orientation : portrait) { 
  #welcome-popup {
    .modal-dialog {
      max-width: 96%;
    }
   }
  }
  @media (max-width: 767px) {
    #welcome-popup {
      .modal-dialog {
        height: 95%;
      }
      .modal-content  {
        border-radius: 8px;
        height:100%;
        background-color:white!important;
        box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.3);
      }
    }
    .welcome-left-side {
      overflow-y: hidden;
      border-radius: 0 0 8px 8px;
      br {
        display: none;
      }
    }
  }
  h1 {
    line-height: 1;
  }
  .welcome-popup-content {
    min-height: 420px;
    margin: 0;
    position: relative;
    border-radius: 3px;
    @media (min-width: 992px) {
      box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.3);
      border: solid 1px #c9c9c9;
    }  
    
    @media (max-width: 991px)  {
      border-radius: 8px;
      margin: 0!important;
    }  
  }
  .welcome-right-side {
    background-image: linear-gradient(#055EA6, #007EE5);
   // margin: -1px;
    @media (max-width: 991px)  {
     border-radius: 8px 8px 0 0;
    } 
  }
  .welcome-left-side {
    @media (min-width: 768px) {
      background: white;
    }
  }
  .welcome-close-link{
    position: absolute;
    right: 15px;
    top: 10px;
    color: #fff;
    z-index: 1;
  }
  i {
    font-size: 14px;
  }
  .mobile-close {
    bottom: 35px;
    right:0;
  }
  .welcome-mobile-close-link {
    display: none;
  }
  @media (max-width: 360px)  {
    .welcome-mobile-close-link {
      display: block;
      z-index: 1;
      i {
        font-size: 20px;
      }
    }
    .mobile-close button { 
      display: none;
    }
  }
</style>
